// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__qSKSl","approved":"Status_approved__1zhwq","rejected":"Status_rejected__3njQR","expired":"Status_expired__mV0OK","label":"Status_label__3jn1n"};